import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { ThemeService } from '../../services/theme.service';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-theme-toggle-btn',
  imports: [ButtonModule],
  templateUrl: './theme-toggle-btn.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeToggleBtnComponent {
  private ts = inject(ThemeService);
  public isDarkTheme = computed(() => this.ts.darkTheme())

  public onToggleTheme = () => this.ts.toggleDarkMode();
 }
